module.exports = __webpack_public_path__ + "img/google_download-icon.99f13238.png";